<template>
  <div v-if="showTable" style="padding: 15px;">
    <el-form ref="form" :rules="rules" :model="form" label-width="100px">
      <el-form-item v-if="isService" label="选择账户" prop="actId">
        <el-cascader
          v-model="company"
          style="max-width:99%;"
          :options="authorizeCompanyOptions"
          @change="handleCompany"
        />
        <!-- <el-select v-model="form.actId" placeholder="请选择" filterable @change="handleChangeActId">
          <el-option-group v-for="item in authorizeCompanyOptions" :key="item.csiId" :label="item.companyName">
            <el-option v-for="item1 in item.accountList" :key="item1.actId" :label="item1.fuelType" :value="item1.actId" />
          </el-option-group>
        </el-select> -->
      </el-form-item>
      <el-form-item label="实际承运人实收现金">
        <el-input v-model="row.deliveryCashFee" :disabled="true" />
      </el-form-item>
      <el-form-item label="已打款金额">
        <el-input v-model="row.allotAmount" :disabled="true" />
      </el-form-item>
      <el-form-item label="已分配油点">
        <el-input v-model="row.allotOil" :disabled="true" />
      </el-form-item>
      <el-form-item label="可分配油点" prop="amount">
        <el-input
          v-model="form.amount"
          @input="
            value => formFormatter.isFloor2(value, oldValue, form, 'amount')
          "
        />
      </el-form-item>
      <el-form-item v-if="isService" label="分配账户品类" prop="category">
        <el-input v-model="row.fuelType" disabled />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :disabled="updating" @click="funcSubmit()"
          >确定</el-button
        >
      </el-form-item>
    </el-form>
    <vxe-table border height="250" :data="tableData">
      <!-- <vxe-table-column field="orderDetailNumber" title="运单号"></vxe-table-column> -->
      <vxe-table-column field="amount" title="分配油点" min-width="260" />
      <vxe-table-column field="gmtCreated" title="分配时间" min-width="220" />
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="form.pageNum"
      :page-size.sync="form.pageSize"
      :total="form.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { remitDefinite, Oilpoint } from "@/api/transport";
import { getAuthorizeCompany } from "@/api/userOil";
import { mayDecimal } from "@/utils/validate4Form.js";
export default {
  name: "AllocateOil",
  data() {
    return {
      loading: false,
      updating: false,
      company: "",
      row: {},
      tableData: [],
      form: {
        actId: "",
        payType: 1,
        amount: "",
        orderDetailCode: "",
        pageNum: 1,
        pageSize: 20,
        totaltotal: 0,
        category: "1"
      },
      Pagingconf: [],
      rules: {
        amount: [
          { required: true, message: "请输入可分配油点", trigger: "blur" },
          { validator: mayDecimal, trigger: "blur" }
        ],
        actId: [{ required: true, message: "请选择账户", trigger: "change" }]
      },
      // categoryOptions:[
      //   {value:'1',label: '柴油'},
      //   {value:'2',label: '天然气'}
      // ],
      authorizeCompanyOptions: [],
      fuelTypeObj: {},
      actIdObj: {},
      isService: false,
      showTable: false
    };
  },
  created() {},
  methods: {
    getInfo(row) {
      this.showTable = false;
      this.getAuthorizeCompany(row.branchCode);
      this.form.amount = (
        row.deliveryCashFee -
        (row.allotAmount + row.allotOil)
      ).toFixed(2);
      this.updating = false;
      this.row = row;
      this.form.orderDetailCode = row.code;
      this.company = "";
      this.form.actId = "";
      this.form.authorizeCuId = "";
      this.form.authorizeZzNumber = "";
      //this.form.amount = "";
      this.Allocationrecord();
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.updating = true;
          const rLoading = this.openLoading();
          Oilpoint(this.form).then(
            response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("hideModel");
            },
            () => (this.updating = false)
          );
        } else {
          return false;
        }
      });
    },
    // 记录列表
    Allocationrecord() {
      this.tableData = [];
      this.loading = true;
      let formData = Object.assign({}, this.form);
      formData.amount = "";
      formData.payerRole = 0;
      remitDefinite(formData).then(response => {
        this.tableData = response.data.records;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
        this.form.total = response.data.total;
        this.loading = false;
      });
    },
    // 分页
    handlePageChange({ currentPage, pageSize }) {
      this.form.pageNum = currentPage;
      this.form.pageSize = pageSize;
      this.Allocationrecord();
    },
    getAuthorizeCompany(branchCode) {
      const rLoading = this.openLoading();
      this.authorizeCompanyOptions = [];
      return getAuthorizeCompany({
        page: 1,
        pageSize: 500,
        receiptCode: "",
        branchCode: branchCode
      })
        .then(response => {
          let data = response.data;
          this.isService = data.isService;
          data.authorizeCompanyList.forEach(item => {
            let obj = {
              value: item.zzNumber,
              label: item.companyName
            };
            if (item.accountList) {
              let children = [];
              item.accountList.forEach(account => {
                children.push({
                  value: account.cuId,
                  label: account.fuelType,
                  disabled: account.actId == ""
                });
                this.fuelTypeObj[account.cuId] = account.fuelType;
                this.actIdObj[account.cuId] = account.actId;
              });
              obj.children = children;
              this.authorizeCompanyOptions.push(obj);
            }
          });
          // this.authorizeCompanyOptions.forEach(item => {
          //   if(item.accountList) {
          //     item.accountList.forEach(account => {
          //       this.fuelTypeObj[account.actId] = account.fuelType
          //     })
          //   }
          // })
        })
        .finally(() => {
          this.showTable = true;
          rLoading.close();
        });
    },
    handleCompany(value) {
      this.form.authorizeZzNumber = value[0];
      this.form.authorizeCuId = value[1];
      this.form.actId = this.actIdObj[value[1]];
      this.row.fuelType = this.fuelTypeObj[value[1]];
    },
    // handleChangeActId(val) {
    //   this.row.fuelType = this.fuelTypeObj[val]
    // }
    isFloor(e) {
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,1})/g)[0] || null;
    }
  }
};
</script>
